<template>
  <div class="dismiss" v-show="showing" ref="root">
    <slot></slot>
  </div>
</template>


<script>
export default {
  name: 'dismiss',
  data() {
    return {
      showing: false,
      listener: null,
    };
  },
  destroyed() {
    this.unlisten();
  },
  methods: {
    open() {
      this.showing = true;
      this.listen();
      this.$emit('opened');
    },
    close() {
      this.showing = false;
      this.unlisten();
      this.$emit('closed');
    },
    toggle() {
      if (this.showing) {
        this.close();
      } else {
        this.open();
      }
    },
    listen() {
      this.listener = (event) => {
        if (!this.$refs.root.contains(event.target)) {
          this.close();
        }
      };
      document.addEventListener('click', this.listener);
    },
    unlisten() {
      document.removeEventListener('click', this.listener);
    },
  },
};
</script>
